import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { startGoogleLogin } from "@/lib/api";
import { FadeIn } from "@/components/common";

const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_goose-platform/artifacts/eydl4x1d_Goose%20Logo2.png";

export default function Landing() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate(user.role === "operator" ? "/admin" : "/producer", { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6 font-[Satoshi,sans-serif] antialiased">
      <FadeIn>
        <div className="flex w-full max-w-[480px] flex-col items-center text-center" style={{ transform: "translateY(-5vh)" }}>
          <img src={LOGO} alt="Goose — powered by HAEVN" className="w-[300px] sm:w-[380px] lg:w-[440px]" data-testid="goose-logo" />

          <p data-testid="goose-tagline" className="mt-5 text-lg font-medium tracking-wide text-[#5A6B7B]">
            Your Intentional Dating Wingman.
          </p>

          <button
            data-testid="signin-btn"
            onClick={() => startGoogleLogin()}
            className="mt-9 inline-flex items-center justify-center gap-2 rounded-full border-2 border-[#FF2A5F] bg-transparent px-7 py-2.5 text-base font-semibold text-[#FF2A5F] transition-colors duration-200 hover:bg-[#FF2A5F] hover:text-white"
          >
            Sign in
            <ArrowRight className="h-4 w-4" />
          </button>

          <p className="mt-5 text-base text-[#5A6B7B]">
            New to Goose?{" "}
            <button
              data-testid="signup-link"
              onClick={() => navigate("/partners")}
              className="inline-flex items-center gap-1 align-baseline font-medium text-[#FF2A5F] hover:underline"
            >
              Sign up
              <ArrowRight className="h-4 w-4" />
            </button>
          </p>
        </div>
      </FadeIn>
    </div>
  );
}
